import type { CardCategoriesType } from '../../shared/types/CardCategories/CardCategoriesType';
import type { MedicationOption } from '../../shared/types/CardCategories/MedicationOption';

type CreateCardCategoriesArgs = {
  manufacturerCardTypeOptions: {
    value: string;
    medications: MedicationOption[];
  };
};

const createCardCategoriesArray = ({
  manufacturerCardTypeOptions,
}: CreateCardCategoriesArgs): CardCategoriesType => {
  if (
    !manufacturerCardTypeOptions?.value ||
    !manufacturerCardTypeOptions?.medications?.length
  ) {
    return null;
  }

  const { value, medications } = manufacturerCardTypeOptions;
  const matchingMedication = medications.find(
    (medicationOption) => medicationOption.value === value,
  );

  if (!matchingMedication) {
    return null;
  }

  return [
    {
      type: 'MANUFACTURER_CARD',
      medications: [matchingMedication],
    },
  ];
};

export default createCardCategoriesArray;
